/* eslint-disable import/prefer-default-export */
import { TimelineVehicleStatesMessages, TranslationTimelineVehicleStatesMessages } from "../interfaces";

export const messages: TranslationTimelineVehicleStatesMessages = {
  [TimelineVehicleStatesMessages.statesTitle]: "Estados",
  [TimelineVehicleStatesMessages.manometer]: "Manômetro",
  [TimelineVehicleStatesMessages.blockedVehicle]: "Veículo bloqueado",
  [TimelineVehicleStatesMessages.blockingDate]: "Momento do bloqueio",
  [TimelineVehicleStatesMessages.postUnloadIdleTime]: "Ociosidade pós-descarga",
  [TimelineVehicleStatesMessages.effectiveUnloadTime]: "Descarga efetiva",
  [TimelineVehicleStatesMessages.unloadBreakdownTitle]: "Dentro do Descarregando",
  [TimelineVehicleStatesMessages.unloadBreakdownHelp]: "Descarga efetiva: balão descarregando.\n"
    + "Ociosidade pós-descarga: balão parado até o caminhão sair da obra."
};
